/*
 * @Descripttion: 咸亨公告页面
 * @Author: 曹博
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 曹博
 * @LastEditTime: 2023-09-24 16:31:28
 */
import UseXhNoticeHook from './hooks'
import styles from './styles.module.scss'
import NewsCard from './components/newsCard'
import { List } from 'antd'
import Search from '../../components/SearchFilter'
import { GetLocalStorage } from '../../tools/util'

const XhNotice = () => {
  const { hookstate, onDetail, onPageChange, handleSearchClick } =
    UseXhNoticeHook()
  const { dataSource, pages, searchData, loading } = hookstate
  return (
    <div className={styles.newBox}>
      <div className={styles['list-container']}>
        <div className={styles['search-container']}>
          <Search
            hideScheme
            keyName="XHANNOUNCEMENT"
            ScreenKey="XHANNOUNCEMENT"
            fieldsData={['announcementTitle']}
            onSearch={handleSearchClick}
          />
        </div>
        <div className={styles['notice-list']}>
          <List
            itemLayout="vertical"
            size="large"
            bordered={false}
            split={false}
            loading={loading}
            pagination={{
              showQuickJumper: true,
              showSizeChanger: true,
              current: pages.pageNo,
              pageSize: pages.pageSize,
              total: dataSource.total,
              showTotal: () => `共${dataSource.total}条数据`,
              onShowSizeChange: (current: number, size: number) => {
                onPageChange(1, size)
              },
              onChange: (page, pageSize?: number) => {
                onPageChange(page, pageSize)
              },
            }}
            dataSource={dataSource.data}
            renderItem={(listItem) => (
              <List.Item className={styles.item}>
                <NewsCard
                  listItem={listItem}
                  imgBaseUrl={GetLocalStorage('BASEURL')}
                  onDetail={onDetail}
                  searchParam={searchData}
                ></NewsCard>
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>
  )
}
export default XhNotice
/*
 * @Descripttion: 咸亨公告页面
 * @Author: 曹博
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 曹博
 * @LastEditTime: 2023-09-24 16:31:28
 */
import UseXhNoticeHook from './hooks'
import styles from './styles.module.scss'
import NewsCard from './components/newsCard'
import { List } from 'antd'
import Search from '../../components/SearchFilter'
import { GetLocalStorage } from '../../tools/util'

const XhNotice = () => {
  const { hookstate, onDetail, onPageChange, handleSearchClick } =
    UseXhNoticeHook()
  const { dataSource, pages, searchData, loading } = hookstate
  return (
    <div className={styles.newBox}>
      <div className={styles['list-container']}>
        <div className={styles['search-container']}>
          <Search
            hideScheme
            keyName="XHANNOUNCEMENT"
            ScreenKey="XHANNOUNCEMENT"
            fieldsData={['announcementTitle']}
            onSearch={handleSearchClick}
          />
        </div>
        <div className={styles['notice-list']}>
          <List
            itemLayout="vertical"
            size="large"
            bordered={false}
            split={false}
            loading={loading}
            pagination={{
              showQuickJumper: true,
              showSizeChanger: true,
              current: pages.pageNo,
              pageSize: pages.pageSize,
              total: dataSource.total,
              showTotal: () => `共${dataSource.total}条数据`,
              onShowSizeChange: (current: number, size: number) => {
                onPageChange(1, size)
              },
              onChange: (page, pageSize?: number) => {
                onPageChange(page, pageSize)
              },
            }}
            dataSource={dataSource.data}
            renderItem={(listItem) => (
              <List.Item className={styles.item}>
                <NewsCard
                  listItem={listItem}
                  imgBaseUrl={GetLocalStorage('BASEURL')}
                  onDetail={onDetail}
                  searchParam={searchData}
                ></NewsCard>
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>
  )
}
export default XhNotice
